export function getRegions() {
    return this.get(`/api/regions/`)
}
export function getRegion(slug) {
    return this.get(`/api/regions/${slug}`)
}
export function putRegion(slug, data) {
    return this.put(`/api/regions/${slug}`, data)
}
